import Signature from './AbstractSignature';
import { CreateElement, VNode } from 'vue';
import { ChildParams, referencesMethod } from '@/templates/References';

export default function GrpcSignatureFactory(kind: string) {
  switch (kind) {
    case 'api_field':
      return GrpcFieldSignature;
    case 'method':
      return GrpcMethodSignature;
    default:
      return {
        getSignature(_method: any): null {
          return null;
        },
      };
  }
}

class GrpcFieldSignature extends Signature {
  public static LANG = 'grpc';

  public static getSignature(field: any): (h: CreateElement) => VNode {
    return (h) =>
      h('code', [
        `${typeof field.title == 'object' && field.title.grpc ? field.title.grpc : field.title}`,
        h('span', { class: 'token punctuation' }, ': '),
        field.type
          ? h('span', {
              class: 'token type md-parse',
              domProps: {
                innerHTML: `${this.convertToHtml(
                  typeof field.type == 'object' && field.type.grpc ? field.type.grpc : field.type
                )}`,
              },
            })
          : '',
      ]);
  }
}

class GrpcMethodSignature extends Signature {
  public static LANG = 'grpc';

  public static getSignature(method: referencesMethod): (h: CreateElement) => VNode {
    const returnsType = this.returnsSignature(method.returns);
    const paramSignatures = this.paramSignatures(method.params);

    return (h) =>
      h('code', [
        h('span', { class: 'token function' }, `${method.title}`),
        h('span', { class: 'token punctuation' }, '('),
        paramSignatures(h),
        h('span', { class: 'token punctuation' }, ')'),
        h('span', { class: 'token punctuation' }, ' '),
        returnsType(h),
      ]);
  }

  private static paramSignatures(paramSignatures: ChildParams[]): (h: CreateElement) => VNode {
    if (!paramSignatures) return (h) => h();

    return (h) =>
      h(
        'span',
        paramSignatures.map((val: ChildParams) => {
          return h('span', [
            `${val.attributes && val.attributes.stream ? 'stream ' : ''}${val.title}`,
          ]);
        })
      );
  }

  private static returnsSignature(returnTypes: ChildParams[]): (h: CreateElement) => VNode {
    if (!returnTypes || !returnTypes.length) return (h) => h();

    return (h) =>
      h(
        'span',
        returnTypes.map((val: ChildParams) => {
          return h('span', [
            `${val.attributes && val.attributes.stream ? 'stream ' : ''}${val.title}`,
          ]);
        })
      );
  }
}
